import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import useLogRecipeEdit from '../../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../../utils/events';
import { DeleteStepIcon } from '../../../utils/iconRefs/recipeStepsIcons';
import { Mode } from '../../ingredientsPage/ingredients.types';
import IngredientsPopup from '../../ingredientsPage/ingredientsPopup';
import LabelConversion from '../../ingredientsPage/ingredientUnitsConversion';
import styles from "./ingredientCreation.module.css";

interface IngredientToDisplay {
  id?: null | string;
  displayName?: string;
  prep?: null;
  image?: boolean;
  type?: string;
  unit?: string;
  tags?: string[];
  critical?: boolean;
  approx?: undefined;
  ingredientDetail?: undefined;
  allergens?: string[];
  nutrientInfo?: {
    fat: string;
    carbs: string;
    calorie: string;
    protein: string;
  };
  alternateNames?: string[];
  alternateIngredients?: null;
  defaultWeight?: {
    value: string,
    valueNumberType: number
    defaultVal?: string,
    displayBtn: boolean,
  };
  weighScaleAmount?: {
    value: string,
    valueNumberType: number
    defaultVal?: string,
    displayBtn: boolean,
  };
  factor?: number;
};

const IngredientCreate = ({ setIngredients, ingredients }: { setIngredients: any, ingredients: any }) => {
  // TODO: the above type to be changed from any
  const { logRecipeEdit } = useLogRecipeEdit();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [ingredientModalMode, setIngredientModalMode] = useState<string | null>(null);
  const [ingredientData, setIngredientData] = useState(null);
  const [ingredientsIndexToEdit, setIngredientsIndexToEdit] = useState(0)

  const deleteIngredients = (index: number) => {
    const newIngredients = [...ingredients];
    newIngredients.splice(index, 1)
    setIngredients(newIngredients);
    logRecipeEdit(EventLogsEnum.APP_ING_REMOVED, {
      eventData: {
        ing_name: ingredients[index].displayName,
        qty: ingredients[index]?.weighScaleAmount?.valueNumberType,
        unit: ingredients[index]?.unit
      }
    })
  }

  const handleEditIngredient = (ingredient: any, index: number) => {
    setIngredientData(ingredient)
    setIsModelOpen(true);
    setIngredientModalMode(Mode.EDIT);
    setIngredientsIndexToEdit(index);
  }

  const handleAddIngredient = () => {
    setIngredientData(null);
    setIsModelOpen(true);
    setIngredientModalMode(Mode.ADD);
  }

  const handleCloseModal = () => {
    setIsModelOpen(false);
    setIngredientModalMode(null);
    setIngredientData(null);
  }

  return (
    <Grid className={styles.layout_box} container direction="column">
      <Grid className={styles.ingredient_header} container direction="row">
        <Grid item xs={6}>
          <Typography>Ingredient</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>Quantity</Typography>
        </Grid>
      </Grid>
      {ingredients?.map((ingredient: any, index: number) =>
        <Grid className={styles.ingredient_view} container direction="row">
          <Grid item onClick={() => deleteIngredients(index)} xs={1}><DeleteStepIcon /></Grid>
          <Grid className={styles.ingredient_list_view} item onClick={() => handleEditIngredient(ingredient, index)}
            xs={10}>
            <Grid item xs={7}>
              <Typography key={ingredient?.id}>{ingredient?.displayName}</Typography>
            </Grid>
            <Divider className={styles.divider} orientation="vertical" variant="middle" />
            <Grid item xs={5}>
              <Typography key={ingredient?.id}>{ingredient?.amount?.qty} {LabelConversion(ingredient?.amount?.unit)?.label}</Typography>
            </Grid>
          </Grid >
        </Grid>
      )}
      <Fab className={styles.add_ingredient_icon} onClick={handleAddIngredient}>
        <AddIcon />
      </Fab>

      <Grid className={styles.ingredient_modal}>
        {isModelOpen && <IngredientsPopup
          ingredientData={ingredientData}
          ingredientModalMode={ingredientModalMode}
          ingredients={ingredients}
          ingredientsIndexToEdit={ingredientsIndexToEdit}
          onClose={handleCloseModal}
          open={isModelOpen}
          setIngredients={setIngredients}
        />}
      </Grid>
    </Grid>
  )
}

export default IngredientCreate;